<template>
    <button
        v-bind="btnBindings"
        @click.prevent="$emit('click')"
    >
        <span class="cf-btn__content">
            <slot>
                <comments-icon
                    v-if="icon"
                    :value="icon"
                    :size="iconSize"
                    class="cf-btn__icon"
                />
                <span
                    v-if="text"
                    class="cf-btn__text"
                >
                    {{ text }}
                </span>
            </slot>
        </span>
    </button>
</template>

<script>
import CommentsIcon from './CommentsIcon'

export default {
    name: 'CommentsButton',
    components: {CommentsIcon},
    props: {
        icon: {
            type: String,
            default: null
        },
        iconSize: {
            type: [ String, Number ],
            default: 16
        },
        text: {
            type: String,
            default: null
        },
        color: {
            type: String,
            default: 'anchor'
        },
        gray: {
            type: Boolean,
            default: false
        },
        block: {
            type: Boolean,
            default: false
        },
        hover: {
            type: Boolean,
            default: false
        },
        link: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        btnBindings() {
            const bindings = {
                class: ['cf-btn', `cf-${this.color}-color`]
            }

            if(this.gray) {
                bindings.class.push('cf-btn--gray')
            }

            if(this.block) {
                bindings.class.push('cf-btn--block')
            }

            if(this.hover) {
                bindings.class.push('cf-btn--hover')
            }

            if(this.link) {
                bindings.class.push('cf-btn--link')
            }

            if(this.disabled) {
                bindings.class.push('cf-btn--disabled')
            }

            return bindings
        }
    }
}
</script>

<style lang=scss>

</style>
